(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uplift-card-sale-badge"] && !Shopify.designMode) return;
  try {
    // Cards for products where only some variants are on sale link to the on-sale variant
  // (…/products/baggy-jeans?variant=123), so the product page opens on the sale colour.
  // Only fills in links that have no ?variant= yet; picking a swatch on the card still wins
  // (Horizon's product-card.js rewrites the links on swatch change).
  (function () {
    function apply(root) {
      (root || document).querySelectorAll('[data-uplift-sale-variant]:not([data-done])').forEach(function (m) {
        m.setAttribute('data-done', '');
        var card = m.closest('product-card');
        if (!card) return;
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          var url = new URL(a.href, location.origin);
          if (url.searchParams.has('variant')) return;
          url.searchParams.set('variant', m.getAttribute('data-uplift-sale-variant'));
          a.href = url.pathname + url.search + url.hash;
        });
      });
    }
    apply();
    // Cards added later (filters, infinite scroll, recommendations).
    var pending = 0;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(apply, 50); })
      .observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uplift-cart-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
  var timer = null;
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function initUcr(scope) {
    var wrap = (scope || document).querySelector('[data-uplift-reviews]');
    if (!wrap) return;
    var items = [].slice.call(wrap.querySelectorAll('.ucr__review'));
    function showOnly(idx) { items.forEach(function (el, i) { el.hidden = i !== idx; }); }
    showOnly(0);
    if (items.length < 2) return;
    stop(); // one timer only — clear any prior before the drawer re-render binds a new wrap
    // Respect reduced-motion: static first review, no rotation (WCAG 2.2.2).
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cur = 0, paused = false;
    function pause() { paused = true; }
    function play() { paused = false; }
    // Pause while the shopper is reading (hover / keyboard focus) — the pause mechanism for 2.2.2.
    wrap.addEventListener('pointerenter', pause);
    wrap.addEventListener('pointerleave', play);
    wrap.addEventListener('focusin', pause);
    wrap.addEventListener('focusout', play);
    timer = setInterval(function () {
      if (!document.body.contains(wrap)) { stop(); return; } // detached on re-render → clear, no leak
      if (paused || wrap.offsetParent === null) return;       // reading, or drawer closed (hidden) → skip
      var next; do { next = Math.floor(Math.random() * items.length); } while (next === cur);
      showOnly(next); cur = next;
    }, 5000);
  }
  initUcr();
  document.addEventListener('shopify:section:load', function (e) { initUcr(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uplift-hover-preload"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__upliftHoverPreload) return;
    window.__upliftHoverPreload = true;
    // Touch screens can't hover: preloading there only steals bandwidth from the first screen (2026-09-24).
    if (!window.matchMedia('(hover: hover)').matches) return;

    function preload(gallery) {
      if (gallery.dataset.upliftPreloaded) return;
      gallery.dataset.upliftPreloaded = '1';
      // Only the HOVER image — the slide immediately after the currently-visible one — NOT every
      // variant/extra image in the card (a product can carry 8-10 media). This keeps the preload
      // to one image per card.
      var visible = gallery.querySelector('slideshow-slide[aria-hidden="false"]')
        || gallery.querySelector('slideshow-slide');
      var hover = visible ? visible.nextElementSibling : null;
      while (hover && (!hover.tagName || hover.tagName.toLowerCase() !== 'slideshow-slide')) {
        hover = hover.nextElementSibling;
      }
      var img = hover ? hover.querySelector('img') : null;
      if (!img || img.dataset.upliftPreloaded) return;
      img.dataset.upliftPreloaded = '1';
      img.loading = 'eager';
      // Warm the cache directly too, so the swap is instant even if a browser ignores the
      // loading-attribute change on an already-parsed <img>.
      var srcset = img.getAttribute('srcset');
      var src = img.getAttribute('src');
      if (srcset || src) {
        var pre = new Image();
        if (img.sizes) pre.sizes = img.sizes;
        if (srcset) pre.srcset = srcset;
        if (src) pre.src = src;
      }
    }

    // On wide screens Horizon scrolls .page-wrapper, not the window; a window-rooted observer then
    // ignores rootMargin and only fires once a card is already on screen.
    function scrollRoot() {
      var pw = document.querySelector('.page-wrapper');
      if (!pw) return null;
      var oy = getComputedStyle(pw).overflowY;
      return oy === 'auto' || oy === 'scroll' ? pw : null;
    }

    function scan() {
      var galleries = document.querySelectorAll('.card-gallery');
      if (!galleries.length) return;
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < galleries.length; i++) preload(galleries[i]);
        return;
      }
      if (!window.__upliftHoverIO) {
        window.__upliftHoverIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              preload(entry.target);
              window.__upliftHoverIO.unobserve(entry.target);
            }
          });
        }, { root: scrollRoot(), rootMargin: '300px 0px' });
      }
      for (var j = 0; j < galleries.length; j++) {
        var g = galleries[j];
        if (g.dataset.upliftObserved) continue;
        g.dataset.upliftObserved = '1';
        window.__upliftHoverIO.observe(g);
      }
    }

    // Wait for the page to finish loading so hover images never compete with the first screen.
    if (document.readyState === 'complete') {
      scan();
    } else {
      window.addEventListener('load', scan, { once: true });
    }
    // Collection filters / pagination re-render via the Section Rendering API.
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uplift-variant-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ucvLoaded) return;
    window.__ucvLoaded = 1;
    var h = document.querySelector('[data-uplift-vgallery][data-src]');
    if (h) {
      var src = h.getAttribute('data-src');
      if (src) { var s = document.createElement('script'); s.src = src; s.defer = true; document.head.appendChild(s); }
    }
  })();

  (function () {
    if (window.__ucSwatchFix) return;
    window.__ucSwatchFix = 1;
    var map = null, fetching = false, themeW = '';

    function buildMap(cb) {
      if (map) { cb(); return; }
      if (fetching) return;
      var vp = document.querySelector('variant-picker');
      if (!vp) return;
      var handle = vp.getAttribute('data-product-handle') || (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
      if (!handle) return;
      fetching = true;
      // Shared cached product-JSON promise so the injected uplift-variant-gallery.js
      // reuses this fetch instead of hitting /products/{handle}.js a second time.
      window.upliftProduct = window.upliftProduct || function (h) {
        window.__upliftProdCache = window.__upliftProdCache || {};
        return window.__upliftProdCache[h] || (window.__upliftProdCache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }));
      };
      window.upliftProduct(handle)
        .then(function (p) {
          var ci = -1;
          (p.options || []).forEach(function (o, i) {
            var n = ((o && o.name) || o || '').toString().toLowerCase();
            if (n.indexOf('color') > -1 || n.indexOf('colour') > -1 || n.indexOf('farge') > -1) ci = i;
          });
          var m = {};
          if (ci > -1) {
            (p.variants || []).forEach(function (v) {
              var c = v.options[ci];
              if (c && !m[c] && v.featured_image && v.featured_image.src) m[c] = v.featured_image.src;
            });
          }
          map = m;
          cb();
        })
        .catch(function () { fetching = false; });
    }

    // Read the width the theme requests for its own swatch images, so ours render identically (same CDN size = same crispness).
    function detectWidth() {
      if (themeW) return;
      document.querySelectorAll('variant-picker .swatch--variant-image').forEach(function (s) {
        if (themeW) return;
        var bg = getComputedStyle(s).getPropertyValue('--swatch-background');
        var wm = bg.match(/[?&]width=(\d+)/);
        if (wm) themeW = wm[1];
      });
      if (!themeW) themeW = '120';
    }

    function sized(u) {
      if (/[?&]width=\d+/.test(u)) return u;
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + themeW;
    }

    function apply() {
      if (!map) return;
      detectWidth();
      document.querySelectorAll('variant-picker .variant-option--swatches .variant-option__button-label').forEach(function (lbl) {
        var sw = lbl.querySelector('.swatch');
        var inp = lbl.querySelector('input');
        if (!sw || !inp) return;
        if (sw.classList.contains('swatch--variant-image')) return;
        var url = map[inp.value];
        if (!url) return;
        sw.style.setProperty('--swatch-background', "url('" + sized(url) + "')");
        sw.classList.add('swatch--variant-image');
        sw.classList.remove('swatch--unavailable');
      });
    }

    function run() { buildMap(apply); }

    run();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    setTimeout(run, 800);
    setTimeout(run, 1800);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) {
        setTimeout(apply, 60);
        setTimeout(apply, 260);
      }
    });

    // Broad observer only while a variant-picker exists, and only briefly — the
    // change listener above + the retry timers handle later variant switches, so we
    // stop observing once the picker has settled (no permanent #MainContent watch).
    if (document.querySelector('variant-picker')) {
      var q = false;
      try {
        var mo = new MutationObserver(function () {
          if (q) return;
          q = true;
          (window.requestAnimationFrame || window.setTimeout)(function () { q = false; run(); }, 0);
        });
        mo.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
        setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 4000);
      } catch (e) {}
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
